<form [formGroup]="form" class="n-form" (ngSubmit)="salvar()">
  <lib-form-field
    [label]="'BARDO_SERVICOS.NOME_CATEGORIA_LABEL' | translate: { termo: $nicho().servico.plural }"
    controlName="nome"
    [required]="true"
    [helpText]="'BARDO_SERVICOS.MINIMO_CARACTERES_HINT' | translate"
  >
    @if (showButton) {
    <p-inputGroup>
      <input
        pInputText
        formControlName="nome"
        [placeholder]="'BARDO_SERVICOS.NOME_CATEGORIA_PLACEHOLDER' | translate: { termo: ($nicho().servico.plural | lowercase) }"
        class="w-full"
      />
      <p-button
        [label]="($modoEdicao ? 'GLOBAL.SALVAR' : 'BARDO_SERVICOS.ADICIONAR') | translate"
        [icon]="$modoEdicao ? 'pi pi-check' : 'pi pi-plus'"
        type="submit"
        [loading]="$loading()"
      />
    </p-inputGroup>
    } @else {
    <input
      pInputText
      formControlName="nome"
      [placeholder]="'BARDO_SERVICOS.NOME_CATEGORIA_PLACEHOLDER' | translate: { termo: ($nicho().servico.plural | lowercase) }"
      class="w-full"
    />
    }
  </lib-form-field>
</form>

